import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [activeNavItem, setActiveNavItem] = useState(0);

  const handleSearch = (e) => {
    e.preventDefault();
    console.log('កំពុងស្វែងរក:', searchQuery);
  };

  const navigationItems = [
    { label: 'ទំព័រដើម', path: '/' },
    { label: 'សេវាកម្ម', path: '/services' },
    { label: 'ការងារ', path: '/worktime' },
    { label: 'អំពីយើង', path: '/about' },
    { label: 'ទំនាក់ទំនង', path: '/contact' }
  ];

  const navIcons = [
    'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
    'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01',
    'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
    'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
    'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
  ];

  const handleNavClick = (index) => {
    setActiveNavItem(index);
  };

  return (
    <>
      {/* Google Fonts */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');
          @import url('https://fonts.googleapis.com/css2?family=Khmer&family=Battambang:wght@300;400;500;600;700&display=swap');
          
          * {
            font-family: 'Poppins', 'Battambang', sans-serif;
          }
          
          .khmer-text {
            font-family: 'Battambang', 'Khmer', cursive;
          }
          
          .english-text {
            font-family: 'Poppins', sans-serif;
          }
        `}
      </style>
      
      <header className="bg-white sticky top-0 z-50 shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            
            {/* ឡូហ្គោ */}
            <Link to="/" className="flex-shrink-0 flex items-center space-x-2">
              <div className="w-10 h-10 bg-[#f2c742] rounded-lg flex items-center justify-center">
                <img src="/img/logo/thekingbeauty.png" alt="ឡូហ្គោ" className="w-8 h-8 object-cover" />
              </div>
              <div>
                <h1 className="text-xl font-semibold text-gray-900 english-text tracking-tight">
                  THE KING BEAUTY
                </h1>
                <p className="text-xs text-gray-500 khmer-text">ឌឹ ឃីង ប៊ីយូធី</p>
              </div>
            </Link>

            {/* ម៉ឺនុយកុំព្យូទ័រ */}
            <nav className="hidden lg:flex space-x-8">
              {navigationItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  className={`text-gray-700 hover:text-[#f2c742] font-medium transition-colors khmer-text`}
                  onClick={() => handleNavClick(index)}
                >
                  {item.label}
                </Link>
              ))}
            </nav>

            {/* ផ្នែកខាងស្តាំ */}
            <div className="hidden lg:flex items-center space-x-4">
              
              {/* ប្រអប់ស្វែងរក */}
              <div className="relative">
                {isSearchOpen ? (
                  <form onSubmit={handleSearch}>
                    <input
                      type="text"
                      placeholder="ស្វែងរក..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="pl-3 pr-10 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f2c742] focus:border-transparent text-gray-700 w-48 khmer-text"
                      onBlur={() => setIsSearchOpen(false)}
                      autoFocus
                    />
                    <button
                      type="submit"
                      className="absolute right-3 top-2.5 text-gray-400 hover:text-[#f2c742]"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </button>
                  </form>
                ) : (
                  <button
                    onClick={() => setIsSearchOpen(true)}
                    className="p-2 text-gray-600 hover:text-[#f2c742] hover:bg-gray-100 rounded-lg transition-colors"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </button>
                )}
              </div>

              {/* ប៊ូតុងកក់ទុក */}
              <Link to="https://t.me/chhanryda" target="_blank" rel="noopener noreferrer">
                <button className="bg-[#f2c742] text-gray-900 px-5 py-2 rounded-lg font-semibold hover:bg-[#e0b53a] transition-colors khmer-text">
                  កក់ទុកឥឡូវនេះ
                </button>
              </Link>
            </div>

            {/* ប៊ូតុងម៉ឺនុយទូរស័ព្ទ */}
            <div className="lg:hidden flex items-center space-x-2">
              <button
                onClick={() => setIsSearchOpen(!isSearchOpen)}
                className="p-2 text-gray-600 hover:text-[#f2c742] hover:bg-gray-100 rounded-lg transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>

              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="p-2 text-gray-600 hover:text-[#f2c742] hover:bg-gray-100 rounded-lg transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {isMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>

          {/* ប្រអប់ស្វែងរកទូរស័ព្ទ */}
          {isSearchOpen && (
            <div className="lg:hidden pb-4">
              <form onSubmit={handleSearch} className="flex">
                <input
                  type="text"
                  placeholder="ស្វែងរកសេវាកម្ម..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="flex-1 px-4 py-2 bg-white border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-[#f2c742] text-gray-700 khmer-text"
                />
                <button
                  type="submit"
                  className="bg-[#f2c742] px-5 py-2 rounded-r-lg hover:bg-[#e0b53a] font-semibold text-gray-900 transition-colors khmer-text"
                >
                  ស្វែងរក
                </button>
              </form>
            </div>
          )}

          {/* ម៉ឺនុយទូរស័ព្ទ */}
          {isMenuOpen && (
            <div className="lg:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1 bg-white border border-gray-200 rounded-lg shadow-lg mt-2">
                {navigationItems.map((item, index) => (
                  <Link
                    key={index}
                    to={item.path}
                    className="block px-3 py-2 text-gray-700 hover:text-[#f2c742] hover:bg-gray-50 rounded-lg font-medium transition-colors khmer-text"
                    onClick={() => {
                      setIsMenuOpen(false);
                      setActiveNavItem(index);
                    }}
                  >
                    {item.label}
                  </Link>
                ))}
                
                <div className="px-3 py-2 border-t border-gray-200 mt-2">
                  <Link to="https://www.facebook.com/people/The-Gilded-OWL-Nail-salon-SPA/61580336022975/" target="_blank" rel="noopener noreferrer">
                    <button className="w-full bg-[#f2c742] text-gray-900 px-5 py-2 rounded-lg font-semibold hover:bg-[#e0b53a] transition-colors khmer-text">
                      កក់ទុកឥឡូវនេះ
                    </button>
                  </Link>
                </div>

                {/* Contact Info in Mobile Menu */}
                <div className="px-3 py-3 mt-2 bg-gray-50 rounded-lg">
                  <div className="flex items-center gap-2 mb-2">
                    <svg className="w-4 h-4 text-[#f2c742]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    <span className="text-sm font-semibold text-gray-900 khmer-text">📞 077221295</span>
                  </div>
                  <div className="flex items-center gap-2 mb-2">
                    <svg className="w-4 h-4 text-[#f2c742]" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                    </svg>
                    <span className="text-sm text-gray-600 khmer-text">Telegram: @chhanryda</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4 text-[#f2c742]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-sm text-gray-600 khmer-text">ម៉ោងបើក៖ 9am - 10pm (រាល់ថ្ងៃ)</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* របារម៉ឺនុយបាតសម្រាប់ទូរស័ព្ទ */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-lg">
        <div className="flex justify-around items-center py-2">
          {navigationItems.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className={`flex flex-col items-center px-2 flex-1 ${
                activeNavItem === index ? 'text-[#f2c742]' : 'text-gray-500'
              } transition-colors`}
              onClick={() => setActiveNavItem(index)}
            >
              <svg 
                className="w-6 h-6 mb-1" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d={navIcons[index]}
                />
              </svg>
              <span className="text-xs font-medium truncate w-full text-center khmer-text">
                {item.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default Header;